module.exports = __webpack_public_path__ + "static/media/science1.1ca9c4af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/img/science1.jpg
// module id = 582
// module chunks = 0